function injectStyle (ssrContext) {
  require("!!../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-0bcb6737\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./NavSidebar.vue")
}
var Component = require("!../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./NavSidebar.vue"),
  /* template */
  require("!!../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0bcb6737\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./NavSidebar.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0bcb6737",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/uikit/components/AppDefaultLayout/components/sections/navSidebar/NavSidebar.vue
// module id = 9435f93585e442f3ae5a
// module chunks = 0